import { get, size } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioCreators } from "modules/portfolio-root/model"
import { Creators as NotificationsCreators } from "modules/notifications/model"
import { classificationsQuery, generateClassificationQuery } from "helpers/classification"
import { getAiTermsAccepted } from "modules/account-root/selectors"
import { getSelectedModelId, getPeriod, getIsActive, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getIsOpPro } from "modules/account-root/selectors"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getIsPortfolioFiltersLoading } from "selectors/portfolios"
import { getStartDate, getEndDate, getPerformanceFetchStartDate, getSelectedDate } from "selectors/dates"
import { getAccount, getAccountId, getAvailableRollups, getPositionSet, getMenuItems, getPortfolioId, getSegment, getSelectedScreen } from "./selectors"
import { getBasePositionSetWithSegment, getBaseSignature } from "./selectors/base"
import { getChips } from "./selectors/chips"
import { getDatesAdjusted, getRiskDate } from "./selectors/dates"
import { getChipSecuritiesIds, getClassificationsTiers, getEditingFilter, getFilterOns, getHasUnsupportedContributionFilter } from "./selectors/filters"
import withUrlParams from "hocs/withUrlParams"
import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: getAccount(state, props),
    accountId: getAccountId(state, props),
    classificationsTiers: getClassificationsTiers(state, props),
    startDate: getStartDate(state, props),
    endDate: getEndDate(state, props),
    modelId: getSelectedModelId(state, props),
    portfolio: get(state, "global.selected.portfolio"),
    portfolioId: getPortfolioId(state, props),
    securitiesIds: getChipSecuritiesIds(state, props),
  }),
  required: ["account", "modelId", "portfolio", "portfolioId"],
  data: [{
    resource: "classifications",
    as: null,
    url: () => ({
      id: "classifications",
      query: classificationsQuery,
    }),
  }, {
    resource: "classificationsValues",
    as: null,
    url: ({ classificationsTiers, startDate }) => {
      if (size(classificationsTiers) === 0 || !startDate) {
        return null
      }

      // We don't know the depth of each classification, generate each classification sub query according to the tier depth
      return {
        id: `classificationsValues-${startDate}${JSON.stringify(classificationsTiers)}`,
        query: `query {
          ${generateClassificationQuery(classificationsTiers)}
        }`,
      }
    },
  }, {
    resource: "portfolioFilters",
    as: null,
    passthrough: true,
    url: ({ account, modelId, portfolioId, startDate, endDate }) => `/api/${account}/m/${modelId}/r/portfolio/${portfolioId}/filters?startDate=${startDate}&endDate=${endDate}&analyzeFactors=true`,
  }, {
    resource: "portfolioSecuritiesDescriptors",
    url: ({ account, modelId, securitiesIds, endDate }) => {
      if (size(securitiesIds) === 0) {
        return null
      }

      return {
        url: `/api/${account}/m/${modelId}/securities/descriptors?date=${endDate}`,
        id: `securitiesDescriptors-${account}${modelId}${endDate}${JSON.stringify(securitiesIds)}`,
        payload: { ids: securitiesIds },
      }
    },
  }],
  actions: {
    ...Creators,
    setExpansionMode: PortfolioCreators.setExpansionMode,
    setPeriod: PortfolioCreators.setPeriod,
    addNotification: NotificationsCreators.add,
  },
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.analyzeFactors"),
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    riskDate: getRiskDate(state, props),
    selectedDate: getSelectedDate(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    availableRollups: getAvailableRollups(state, props),
    chips: getChips(state, props),
    editingFilter: getEditingFilter(state, props),
    filterOns: getFilterOns(state, props),
    selectedScreen: getSelectedScreen(state, props),
    segment: getSegment(state, props),
    menuItems: getMenuItems(state, props),
    firstDate: getPerformanceFetchStartDate(state, props),
    period: getPeriod(state, props),
    isActive: getIsActive(state, props),
    hasUnsupportedContributionFilter: getHasUnsupportedContributionFilter(state, props),
    positionSet: getPositionSet(state, props),
    base: getBasePositionSetWithSegment(state, props),
    baseSignature: getBaseSignature(state, props),
    currency: getCurrency(state, props),
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state, props),
    isAiTermsAccepted: getAiTermsAccepted(state, props),
    isPortfolioFiltersLoading: getIsPortfolioFiltersLoading(state, props),
    isOpPro: getIsOpPro(state, props),
  }),
}))
